module.exports = __webpack_public_path__ + "static/media/ic_proyectos_energy_pin.a847f375.svg";